<div class="agpr-multiContentLibraryPanel">
    <div class="agpr-multiContentLibraryPanel-field">
        @if (field.hidePanel) {
            <ng-container
                *ngTemplateOutlet="content"
            ></ng-container>
        } @else {
            <agpr-panel
                [header]="field.label"
                [paddingBottom]="0"
            >
                <ng-container
                    *ngTemplateOutlet="content"
                ></ng-container>
            </agpr-panel>
        }
    </div>
</div>


<ng-template #content>
    <div class="agpr-blockForm panel-container agpr-multiContentLibraryPanel-container">
        <div
            class="agpr-multiContentLibraryPanel-field-noImage"
            [ngClass]="{'agpr-multiContentLibraryPanel-field-subLabel' : !!field.subLabel}"
        >
            @if (field.subLabel) {
                <span>
                    {{ field.subLabel | localize }}
                </span>
            } @else if (maxFiles > 1) {
                <span>
                    {{ 'Briefings.fields.image.selectUpTo' | localize : { count: maxFiles } }}
                </span>
            } @else {
                <span>
                    {{ 'Briefings.fields.image.selectOnlyOne' | localize }}
                </span>
            }
        </div>
        <div class="agpr-multiContentLibraryPanel-upload">
            <agpr-split-button
                [icon]="uploadIcon"
                panelPositionY="bottom"
                panelPositionX="right"
                [tooltip]="maxFiles > 1 && (value?.length >= maxFiles) ? 'Common.forms.maxAllowed' : 'Discover.distribution.imageUpload.tooltip'"
                tooltipPosition="top"
                [options]="uploadOptions"
                [disabled]="maxFiles > 1 && (value?.length >= maxFiles)"
                [primaryTriggerIcon]="true"
            ></agpr-split-button>
        </div>
    </div>
    <div>
        @if (hasAutomateImage) {
            <agpr-message
                [severity]="messageSeverityEnum.info"
            >
                <span [innerHtml]="'Mention.editDialog.image.automate.info' | localize"></span>
            </agpr-message>
        }
        @if (value?.length > 0) {

            @for (file of value; track i; let i = $index) {
                <div class="agpr-multiContentLibraryPanel-field-files-item">
                    <div class="agpr-multiContentLibraryPanel-field-thumbnail-container">
                        @if ((file.url
                            && (file.mimeType === 'image/png' || file.mimeType === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpeg')
                            && !file.hasError && !file.noThumbnail)) {
                            <img
                                [src]="file.url + '?isThumbnail=true'"
                                class="agpr-multiContentLibraryPanel-field-thumbnail-container--image"
                                (error)="file.noThumbnail = true"
                            >
                        } @else if (file.url && !file.hasError) {
                            <img
                                [src]="file.url"
                                class="agpr-multiContentLibraryPanel-field-thumbnail-container--image"
                                (error)="file.hasError = true"
                            >
                        } @else if (file.imageSource === imageSources.AUTOMATE) {
                                    <span class="agpr-contentLibraryItem-thumbnail-placeholder fa-duotone fa-regular fa-bolt-auto"></span>
                        } @else {
                            <span class="agpr-contentLibraryItem-thumbnail-placeholder fa-regular fa-duotone fa-file-image"></span>
                        }
                    </div>
                    <div
                        class="agpr-multiContentLibraryPanel-field-fileContainer"
                        [ngClass]="{'agpr-multiContentLibraryPanel-field-fileContainer-noTopPadding' : !file.name}"
                    >
                        @if (file.name) {
                            <span
                                class="agpr-multiContentLibraryPanel-field-fileName"
                                [agprTooltip]="file.name"
                            >
                                {{ file?.name }}
                            </span>
                        } @else if (file.imageSource === imageSources.AUTOMATE) {
                            <span class="agpr-multiContentLibraryPanel-field-fileName">
                                {{'Mention.editDialog.image.automatedFromMention' | localize}}
                            </span>
                        } @else {
                            <agpr-text-input
                                [id]="id + '.textFieldInput'"
                                [(ngModel)]="file.url"
                                [maxLength]="255"
                                [ariaInvalid]="!!file?.errorMessage"
                                (input)="onUrlInput(file, $event)"
                                (blur)="onUrlBlur(file)"
                                [bottomMargin]="false"
                                [ariaDescribedBy]="id + '_error' + (field.description ? ' ' + id + '_description' : '')"
                                [placeholder]="field.placeholder | localize"
                            ></agpr-text-input>

                            @if (file?.errorMessage) {
                                <agpr-form-message [id]="i + '_error'">
                                    {{ file?.errorMessage | localize }}
                                </agpr-form-message>
                            }
                        }
                        @if (file.imageSource !== imageSources.AUTOMATE) {
                            <div class="agpr-multiContentLibraryPanel-field-altText">
                                <agpr-checkbox
                                    [binary]="true"
                                    [(ngModel)]="value[i].showAltText"
                                    [label]="'Common.forms.altText'"
                                    (onChange)="changeAltText(value[i])"
                                >
                                </agpr-checkbox>
                            </div>
                        }
                        @if (value?.[i]?.showAltText) {
                            <div class="agpr-multiContentLibraryPanel-field-inputText">
                                <agpr-text-input
                                    [id]="'altTextInput_' + i"
                                    [(ngModel)]="value[i].altText"
                                    [placeholder]="'Common.forms.enterAltText'"
                                    [maxLength]="255"
                                    [bottomMargin]="false"
                                    (ngModelChange)="emitChanges()"
                                >
                                </agpr-text-input>
                            </div>
                        }
                    </div>

                    <div class="agpr-multiContentLibraryPanel-field-files-action">
                        @if (value?.length > 1) {
                            <agpr-button
                                [id]="'briefing.images.moveUp_'+i"
                                [style]="buttonTypes.icon"
                                icon="fa-regular fa-arrow-up"
                                [disabled]="i === 0"
                                (click)="moveUp(i)"
                            ></agpr-button>
                            <agpr-button
                                [id]="'briefing.images.moveDown_'+i"
                                [style]="buttonTypes.icon"
                                icon="fa-regular fa-arrow-down"
                                [disabled]="i === (value.length - 1)"
                                (click)="moveDown(i)"
                            ></agpr-button>
                        }
                        @if (maxFiles > 1 || field.showRemoveButtonAlways) {
                            <agpr-button
                                icon="fa-regular fa-duotone fa-square-xmark"
                                agprTooltip="PageBuilder.formField.removeFile"
                                tooltipPosition="top"
                                [style]="buttonTypes.icon"
                                (click)="removeFile(i)"
                            ></agpr-button>
                        }
                    </div>
                </div>
            }
        }

        @if (value?.length === 0) {
            <agpr-message [severity]="messageSeverityEnum.noContent" [useWhiteBg]="true">
                {{'Mention.workbench.image.noImage' | localize}}
            </agpr-message>
        }
        @if (showFirstImageWarning) {
            <agpr-message [severity]="messageSeverityEnum.warning" [useWhiteBg]="true">
                {{'Briefings.fields.image.onlyShowFirstImage' | localize}}
            </agpr-message>
        }
    </div>
</ng-template>